import { getSettings } from '../redux/api/settings-api'
import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { useTranslation } from 'react-i18next'
import { toast } from '@itsrever/design-system'
import { useSearchParams } from 'react-router'
import { useEcommerceId } from './use-ecommerce-id'

export function useSettings() {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const settingsApiSettings = useAppSelector(
    (store) => store.settingsApi.settings
  )

  const [searchParams] = useSearchParams()

  const ecommerceIdParam = searchParams.get('ecommerce_id')

  // Falls back to the first portal in the group view: these settings feed per-portal reads all
  // over the app (theme preview, banners, the navbar), which have nothing to show without them.
  const fallbackEcommerceId = useEcommerceId()

  const ecommerceId = ecommerceIdParam ?? fallbackEcommerceId

  useEffect(() => {
    if (ecommerceId) dispatch(getSettings(ecommerceId))
  }, [ecommerceId, dispatch])

  useEffect(() => {
    if (settingsApiSettings.loading === 'failed') {
      toast({
        text: t('toast_errors.landing_settings_error'),
        variant: 'error'
      })
    }
  }, [settingsApiSettings.loading, t])
}
